import { Grid, Paper, Stack, Typography } from '@mui/material';
import { type Theme, useTheme } from '@mui/material/styles';
import type { FormEventHandler, ReactNode } from 'react';

const getStyles = (theme: Theme, hasLogo: boolean) => ({
  publicForm: {
    width: '350px',
    padding: theme.spacing(2)
  },
  header: {
    marginTop: theme.spacing(-2),
    marginLeft: theme.spacing(-2),
    marginRight: theme.spacing(-2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderTopLeftRadius: theme.shape.borderRadius,
    borderTopRightRadius: theme.shape.borderRadius,
    height: hasLogo ? '250px' : '120px',
    //clipPath: 'polygon(0 0, 100% 0%, 100% 70%, 0% 100%)',
    clipPath:
      'polygon(0% 0%, 100% 0%, 100% 100%, 93% 94%, 88% 100%, 80% 94%, 73% 100%, 65% 94%, 58% 100%, 50% 94%, 42% 100%, 36% 94%, 29% 100%, 21% 93%, 14% 100%, 7% 94%, 0% 100%)',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  },
  center: {
    display: 'flex',
    justifyContent: 'center'
  }
});

interface PublicFormProps {
  onSubmit: FormEventHandler<any>;
  title: string;
  subtitle: string;
  children: ReactNode[];
  logo?: string;
}

const PublicForm = (props: PublicFormProps) => {
  const theme = useTheme();
  const classes = getStyles(theme, !!props.logo);
  return (
    <Paper variant="outlined" sx={classes.publicForm}>
      <form noValidate autoComplete="off" onSubmit={props.onSubmit}>
        <Grid container direction="column" spacing={2}>
          <Grid sx={classes.header}>
            <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
              {props.logo && <img src={props.logo} alt="Logo" width={150} height={150} />}
              <Typography variant="h4">{props.title}</Typography>
            </Stack>
          </Grid>
          <Grid sx={classes.center}>
            <Typography variant="subtitle1">{props.subtitle}</Typography>
          </Grid>
          {props.children}
        </Grid>
      </form>
    </Paper>
  );
};

export default PublicForm;
